import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from '../libs/auth.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page'),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard', //대시보드
        loadComponent: () => import('./pages/dashboard/dashboard.page'),
      },
      {
        path: 'user', // 회원 관리
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/user/user.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/user/user-detail/user-detail.page'),
          },
        ],
      },

      {
        path: '',
        redirectTo: 'vendor',
        pathMatch: 'full',
      },
      {
        path: 'vendor', // 입점사 관리
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/vendor/vendor.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/vendor/vendor-detail/vendor-detail.page'),
          },
        ],
      },
      {
        path: 'client', // 고객사 관리,
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/client/client.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/client/client-detail/client-detail.page'),
          },
        ],
      },
      {
        path: 'credit-request',
        loadComponent: () =>
          import('./pages/credit-request/credit-request.page'),
      },
      {
        path: 'credit-history',
        loadComponent: () =>
          import('./pages/credit-history/credit-history.page'),
      },
      {
        path: 'notice',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/notice/notice.page'),
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./pages/notice/create-notice/create-notice.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/notice/notice-detail/notice-detail.page'),
          },
          {
            path: ':id/update',
            loadComponent: () =>
              import('./pages/notice/create-notice/create-notice.page'),
          },
        ],
      },
      {
        path: 'inquiry',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/inquiry/inquiry.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/inquiry/inquiry-detail/inquiry-detail.page'),
          },
        ],
      },
      {
        path: 'introduction-inquiry',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/introduction-inquiry/introduction-inquiry.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/introduction-inquiry/introduction-inquiry-detail/introduction-inquiry-detail.component'
              ),
          },
        ],
      },
      {
        path: 'contents-request',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/contents-request/contents-request.page'),
          },

          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/contents-request/contents-request-detail/contents-request-detail.page'
              ),
          },
        ],
      },
      {
        path: 'company-info',
        loadComponent: () => import('./pages/company-info/company-info.page'),
      },

      {
        path: 'terms',
        loadComponent: () => import('./pages/terms/terms.page'),
      },
      {
        path: 'admin',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/admin/admin.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/admin/admin-detail/admin-detail.page'),
          },
        ],
      },
      {
        path: 'build-file',
        loadComponent: () => import('./pages/build-file/build-file.page'),
      },
      // {
      //   path: 'survey',
      //   children: [
      //     {
      //       path: '',
      //       loadComponent: () => import('./pages/survey/survey.page'),
      //     },

      //     {
      //       path: ':id',
      //       loadComponent: () =>
      //         import('./pages/survey/survey-detail/survey-detail.page'),
      //     },
      //   ],
      // },
    ],
  },
  {
    path: 'not-found',
    loadComponent: () => import('./pages/not-found/not-found.page'),
  },
  {
    path: '**',
    redirectTo: 'not-found',
    pathMatch: 'full',
  },
];
